export enum BOOKING_STATUS {
  confirmed = 'CONFIRMED',
  completed = 'COMPLETED',
  accepted = 'ACCEPTED',
  arrived = 'ARRIVED',
  seated = 'SEATED',
  released = 'RELEASED',
  pending = 'PENDING',
  toReview = 'TO_REVIEW',
  incomplete = 'INCOMPLETE',
  rejected = 'REJECTED',
  charged = 'CHARGED',
  noShow = 'NOT_SHOW',
  cancelled = 'CANCELLED',
  available = 'AVAILABLE',
  locked = 'LOCKED'
}
